<template>
	<div>
    <div style="display: flex; justify-content: space-between; align-items: center" class="">
			<div><h3>Product ID: {{ inventoryCache.id }}</h3></div>
			<div></div>
    </div>

    <div style="display: flex; justify-content: space-between; align-items: center" class="">
			<div><h3>SKU: {{ inventoryCache.sku }}</h3></div>
			<div></div>
    </div>

		<div style="display: flex; justify-content: space-between; align-items: center" class="">
			<div><h3>size_converted_min</h3></div>
			<div>
				<div style="display: inline-block" class="small-margin-right">
					<input class="full-width small-margin-top"
            :class="!this.min_validation ? 'has-error': ''"
            type="number" v-model="converted_min"
            placeholder=""/>
				</div>
      </div>
		</div>
		<div style="display: flex; justify-content: space-between; align-items: center" class="">
			<div><h3>size_converted_max</h3></div>
			<div>
				<div style="display: inline-block" class="small-margin-right">
					<input class="full-width small-margin-top"
            :class="!this.max_validation ? 'has-error': ''"
            type="number" v-model="converted_max"
            placeholder=""/>
				</div>
      </div>
		</div>

		<div class="small-margin-top small-padding-top border-top text-right">
			<button :disabled="!this.converted_min || !this.converted_max" v-on:click="editConvertedValue()">Save</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import _ from 'lodash'

export default {
  props: {
    inventoryCache: {
      type: Object
    },
    productId: {
      type: Number
    }
  },
  data: () => ({
    converted_min: null,
    converted_max: null,
    saving: false,
    min_validation: true,
    max_validation: true
  }),
  methods: {
    editConvertedValue () {
      Vue.$api.post('/product/' + this.productId + '/convert-size', {
        size: this.inventoryCache.size,
        min: this.converted_min,
        max: this.converted_max
      }, {
        before: () => this.saving = true,
        always: () => this.saving = false,
        callback: () => {
          this.inventoryCache.size_converted_min = this.converted_min
          this.inventoryCache.size_converted_max = this.converted_max
          this.$emit('success')
        },
        error: (err) => {
          if (err.data && err.data.message) {
            alert(err.data.message)
          }
        }
      })
      this.$emit('success')
    },
    toggleCancelModal () {
      this.$emit('closeModal')
    },
    beforeunload () {
      this.converted_min = this.inventoryCache.size_converted_min
      this.converted_max = this.inventoryCache.size_converted_max
    }
  },
  created () {
    window.addEventListener('beforeunload', this.beforeunload())
  }
}
</script>
<style lang="less" scoped>
	.has-error {
		border-color: #FE0006;
	}

</style>
